import { Component, Input } from '@angular/core';
import { AutoCompleteSearchDropdownOptionsI } from '../autocomplete-field/autocomplete-field.interface';

@Component({
  selector: 'app-make-model-selector',
  templateUrl: './make-model-selector.component.html',
  styleUrls: ['./make-model-selector.component.scss']
})
export class MakeModelSelectorComponent {
  @Input('lob') lob: string;

  controlName = 'mmvSelector';

  autoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI = {
      searchApiUrl: '/services/api/v1/advance_rule_search/mmv',
      dataApiUrl: '/services/api/v1/advance_rule_search/get-mmvs',
      queryParamKey: 'search_text',
      dataIdKey: 'combined_value',
      dataNameKey: 'abbr',
      toolTipType: 'items'
  }

  ngOnInit() {
      console.log('innit', this.lob);
      this.autoCompleteFieldOptions.searchApiUrl = `/services/api/v1/advance_rule_search/mmv?lob=${this.lob}`;
    }
}
